import "Layouts/default";

import "Ui/slider";
import "Ui/tabs";

import "Common/social";
import "Common/lightgallery";
import { updateLazy } from "Functions/lazy";
import { scrollToEl } from "Functions/anchor";

document.addEventListener("DOMContentLoaded", function () {
    updateLazy();
});

document
    .querySelector(".c-article")
    .querySelectorAll('[href^="#"]')
    .forEach((anchor) => {
        anchor.addEventListener("click", (event) => {
            event.preventDefault();
            scrollToEl(document.querySelector(event.currentTarget.getAttribute("href")), 30);
        });
    });

setTimeout(function () {
    if (location.hash) {
        window.scrollTo(0, 0);
        scrollToEl(document.querySelector(location.hash), 30);
    }
}, 1);

$(function () {
    $(".js-share-current-url").on("click", async function () {
        const shareData = {
            title: document.querySelector('meta[property="og:title"]').content,
            url: window.location.href,
        };
        try {
            await navigator.share(shareData);
        } catch (err) {
            if (err && err.name === "AbortError") {
                return;
            }
            try {
                // copy url to clipboard if share is not supported
                await navigator.clipboard.writeText(shareData.url);
                Eshop.alert($(this).data("success"));
            } catch (err) {
                Eshop.alert($(this).data("error"), { type: "error" });
            }
        }
    });
});
